export const environment = {
  production: false,
  backendApiUrl: 'https://app-backend-tfsat-dev.azurewebsites.net',
  domain: 'reishauer-dev.eu.auth0.com',
  audience: 'https://reishauer-dev.eu.auth0.com/api/v2/',
  clientId: 'Jk0AI7O3wQx1sMMHMAwRlVf1gbZiKcc4',
  redirectUri: window.location.origin,
  applicationUrl: 'https://dev.myreishauer.com',
};
